import { render, staticRenderFns } from "./right-side-bar.vue?vue&type=template&id=e248c31c&"
import script from "./right-side-bar.vue?vue&type=script&lang=js&"
export * from "./right-side-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports